/* ============================================================
   AARK — Slideshow Engine
   aark-slideshow.js
   ============================================================ */

(function () {
  'use strict';

  function AarkSlideshow(el) {
    this.el        = el;
    this.track     = el.querySelector('#slideshow-track');
    this.slides    = Array.from(el.querySelectorAll('.slide'));
    this.dotsWrap  = el.querySelector('#slideshow-dots');
    this.counter   = el.querySelector('#slide-current');
    this.total     = el.querySelector('#slide-total');
    this.prevBtn   = el.querySelector('.slideshow__arrow--prev');
    this.nextBtn   = el.querySelector('.slideshow__arrow--next');
    this.progressBar = el.querySelector('#slide-progress');
    this.current   = 0;
    this.autoplay  = el.dataset.autoplay === 'true';
    this.speed     = parseInt(el.dataset.speed, 10) || 5000;
    this.timer     = null;
    this.progTimer = null;

    if (this.slides.length === 0) return;

    this._buildDots();
    this._updateCounter();
    this._bindEvents();
    if (this.autoplay) this._startAutoplay();
    this._animateContent(0);
  }

  AarkSlideshow.prototype._buildDots = function () {
    if (!this.dotsWrap) return;
    this.dots = this.slides.map(function (_, i) {
      var btn = document.createElement('button');
      btn.className = 'slideshow__dot' + (i === 0 ? ' is-active' : '');
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      this.dotsWrap.appendChild(btn);
      return btn;
    }, this);
  };

  AarkSlideshow.prototype._updateCounter = function () {
    if (this.counter) this.counter.textContent = this.current + 1;
    if (this.total)   this.total.textContent   = this.slides.length;
  };

  AarkSlideshow.prototype._goTo = function (index) {
    var prev = this.current;
    this.current = (index + this.slides.length) % this.slides.length;

    this.slides[prev].classList.remove('is-active');
    this.slides[prev].classList.add('is-leaving');
    var self = this;
    setTimeout(function () {
      self.slides[prev].classList.remove('is-leaving');
    }, 900);

    this.slides[this.current].classList.add('is-active');
    this._animateContent(this.current);

    if (this.dots) {
      this.dots[prev].classList.remove('is-active');
      this.dots[prev].setAttribute('aria-selected', 'false');
      this.dots[this.current].classList.add('is-active');
      this.dots[this.current].setAttribute('aria-selected', 'true');
    }

    this._updateCounter();

    if (this.autoplay) {
      this._resetProgress();
      this._startProgress();
    }
  };

  AarkSlideshow.prototype._animateContent = function (index) {
    var slide = this.slides[index];
    var items = slide.querySelectorAll('.hero-eyebrow, .hero-headline, .hero-sub, .hero-actions');
    items.forEach(function (el) {
      el.classList.add('slide-animate');
    });
  };

  AarkSlideshow.prototype._bindEvents = function () {
    var self = this;

    if (this.prevBtn) this.prevBtn.addEventListener('click', function () {
      self._goTo(self.current - 1);
      if (self.autoplay) self._restartAutoplay();
    });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () {
      self._goTo(self.current + 1);
      if (self.autoplay) self._restartAutoplay();
    });

    if (this.dots) {
      this.dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          self._goTo(i);
          if (self.autoplay) self._restartAutoplay();
        });
      });
    }

    // Touch / swipe
    var startX = 0;
    this.el.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    this.el.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        self._goTo(diff > 0 ? self.current + 1 : self.current - 1);
        if (self.autoplay) self._restartAutoplay();
      }
    });

    // Keyboard
    this.el.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  self._goTo(self.current - 1);
      if (e.key === 'ArrowRight') self._goTo(self.current + 1);
    });

    // Pause on hover
    this.el.addEventListener('mouseenter', function () { if (self.autoplay) self._pauseAutoplay(); });
    this.el.addEventListener('mouseleave', function () { if (self.autoplay) self._restartAutoplay(); });
  };

  AarkSlideshow.prototype._startAutoplay = function () {
    var self = this;
    this._startProgress();
    this.timer = setInterval(function () { self._goTo(self.current + 1); }, this.speed);
  };

  AarkSlideshow.prototype._pauseAutoplay = function () {
    clearInterval(this.timer);
    clearInterval(this.progTimer);
    if (this.progressBar) this.progressBar.style.transition = 'none';
  };

  AarkSlideshow.prototype._restartAutoplay = function () {
    this._pauseAutoplay();
    this._startAutoplay();
  };

  AarkSlideshow.prototype._startProgress = function () {
    if (!this.progressBar) return;
    var self = this;
    this.progressBar.style.transition = 'none';
    this.progressBar.style.width = '0%';
    setTimeout(function () {
      self.progressBar.style.transition = 'width ' + self.speed + 'ms linear';
      self.progressBar.style.width = '100%';
    }, 30);
  };

  AarkSlideshow.prototype._resetProgress = function () {
    if (!this.progressBar) return;
    this.progressBar.style.transition = 'none';
    this.progressBar.style.width = '0%';
  };

  // Init on DOM ready
  document.addEventListener('DOMContentLoaded', function () {
    var el = document.querySelector('.slideshow');
    if (el) window.__aarkSlideshow = new AarkSlideshow(el);
  });

})();
